export default "__VITE_ASSET__05sJk5X1__"